/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable global-require */
import { Card, CardItemPro, Modal } from '@presentation/components';
import { BREAKPOINTS } from '@presentation/styles';
import { useTranslation } from '@presentation/utils';
import type { FC } from 'react';
import { Suspense, lazy, useMemo } from 'react';
import { BiRefresh } from 'react-icons/bi';
import { useMediaQuery } from 'react-responsive';
import * as Styled from '../../styled';
import type { MapProps } from '../Map/types';
import { MapFilters } from '../MapFilters';
import type { MapModalProps } from './types';

const Map = lazy(() => import('../Map').then((module) => ({ default: module.default })));

export const MapModal: FC<MapModalProps> = (props) => {
  const { map, proSearch } = props;

  const { translate } = useTranslation();
  const phoneBreakpoint = useMediaQuery({ query: `(max-width: ${BREAKPOINTS.small}px)` });

  const mapPropsWithoutPopup = useMemo((): MapProps => {
    return {
      ...map.props,
      markers: map.props.markers.map((item) => ({ ...item, popup: undefined })),
    };
  }, [map]);

  return (
    <Modal {...map.modal}>
      <Card isModal size="fullscreen" noPadding={phoneBreakpoint}>
        <Styled.StyledModalCloseButton modal={map.modal} />
        {(map.canRefresh || map.loading) && (
          <Styled.MapRefreshButton
            color="blue"
            shrink
            iconLeft={map.loading ? undefined : <BiRefresh />}
            onClick={map.onRefreshClick}
            loading={map.loading}
          >
            {translate('common.buttons.refreshMap')}
          </Styled.MapRefreshButton>
        )}

        <Suspense fallback="...">
          <Map {...mapPropsWithoutPopup} />
        </Suspense>

        <Styled.MapFiltersWrapper>
          <MapFilters proSearch={proSearch} />
        </Styled.MapFiltersWrapper>
        <Styled.MapProCardWrapper>
          {map.selectedLoading && (
            <Styled.MapProLoadingWrapper>
              <Styled.StyledLoading color="dark" type="puff" />
            </Styled.MapProLoadingWrapper>
          )}
          {map.selectedPro && <CardItemPro {...{ ...map.selectedPro, image: undefined }} />}
        </Styled.MapProCardWrapper>
      </Card>
    </Modal>
  );
};
